import React from "react";
import { currency } from "../../../utils/currency/currency";

export const getDropDownLabel = (values, fieldValue) => {
  let valueLabel = null;
  if (fieldValue === null) return "--";
  values?.forEach((item) => {
    if (
      item.value &&
      fieldValue &&
      item.value.toString() === fieldValue.toString()
    ) {
      valueLabel = item.label;
    }
    if (item.value !== undefined && item.value === Boolean(fieldValue)) {
      valueLabel = item.label;
    }
    if (
      item !== undefined &&
      fieldValue !== undefined &&
      item.toString() &&
      fieldValue.toString() &&
      item.toString() === fieldValue.toString()
    ) {
      valueLabel = item;
    }
  });
  return valueLabel || "--";
};

export const checkBoxReadableValues = (value) => {
  if (value === true) {
    return "Yes";
  }
  if (value === false) {
    return "No";
  }

  return value || "--";
};

export const RadioMultiSupport = (values, fieldValue) => {
  const matchedItem = values.find((item) => {
    return Array.isArray(item.value)
      ? item.value.includes(fieldValue)
      : item.value === fieldValue;
  });

  return matchedItem ? matchedItem.label : "--";
};

export const isNullOrUndefinedOrEmpty = (value) => {
  if (value === null || value === undefined || value === "") {
    return "--";
  }
  return value;
};

export const maskSSN = (ssn) => {
  if (!ssn) {
    return "--";
  }
  const maskedSSN = ssn.slice(-4);
  return `XXX-XX-${maskedSSN}`;
};

export const getCurrencyFormat = (value) => {
  if (value === null || value === undefined || value === "") {
    return "--";
  }
  return currency(value)?.format();
};

export function formatSSN(value) {
  // Remove any non-digit characters from the input
  const cleanedValue = value?.replace(/\D/g, "");

  // Check if the cleaned value matches the pattern
  if (/^\d{3}-?\d{2}-?\d{4}$/.test(cleanedValue)) {
    // If it matches, return the formatted SSN
    return cleanedValue?.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
  }
  if (cleanedValue === "XXX-XX-XXXX") {
    // If it's already in the correct format, return it as is
    return cleanedValue;
  }
  // If it doesn't match the pattern, return an empty string or handle it as needed
  return "--";
}

export const formatEIN = (value) => {
  if (!value) return "--"; // Return empty string if value is empty

  // Remove any non-digit characters
  const cleanedValue = value.replace(/\D/g, "");

  // Format the cleaned value as EIN
  return cleanedValue.replace(/^(\d{2})(\d{7})$/, "$1-$2");
};

export const getDropDownText = (value, isTooltip) => {
  const match = value?.match(/(\d+) (.+)/);
  const code = match ? match[1] : "";
  const label = match ? match[2] : "";
  if (isTooltip) return `${code} | ${label}`;
  return (
    <span>
      <span style={{ color: "#49677c", fontWeight: "600", fontSize: "14px" }}>
        {code}
      </span>
      <span style={{ color: "#3C3C3C" }}> {`| ${label}`}</span>
    </span>
  );
};

export const getMonthsLabels = (fieldValue) => {
  const num = Number(fieldValue);
  if (Number?.isNaN(num) || num <= 0) return "--";
  return `${num} Month${num === 1 ? "--" : "s"}`;
};
